export const SPexceptions: Record<number, string> = {
    101: "Test Exception",
    102: "New Donor Record.",
};